<button class="toggle-btn" (click)="toggle()">
    <mat-icon>{{ open ? 'chevron_right' : 'chevron_left' }}</mat-icon>
</button>

<div class="content" *ngIf="open">
    <shared-forklift-right-route class="route-area" [value]="selectedRoute"
        (refresh)="onRouteRefresh($event)"></shared-forklift-right-route>
    <shared-forklift-right-actions class="actions-column" [style.flex-basis.px]="actionsWidth" [value]="selectedRoute"
        (refresh)="onRouteRefresh($event)"></shared-forklift-right-actions>
</div>